/** Remove `.modal-backdrop` órfãos e desbloqueia o `body` quando não há
 * nenhum modal bs5 genuinamente aberto.
 *
 * Bootstrap 5 marca o `body` (classe `modal-open`, `overflow:hidden`) e injecta
 * um `.modal-backdrop` sempre que um modal abre; se a instância for destruída
 * fora do fluxo normal (ex.: navegação para outra rota, ou o próprio elemento
 * do modal for removido pela reactividade do Vue a meio da transição), essa
 * limpeza pode nunca correr — a app fica com o overlay e o bloqueio de scroll
 * presos, parecendo "bloqueada", só resolvido com um refresh. */
export function limparBackdropsOrfaos(): void {
  if (document.querySelector(".modal.show")) return;

  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
}
